// extracted by mini-css-extract-plugin
module.exports = {"bold":"RiskApplicationApproval_bold_xPBzF"};